import { APIRoute } from '@/modules/utils'
import { HydraCollection, HydraSearchParams, IRI } from 'emt-library'
import { UserCard } from '@/dataV3/Search/UserCard'

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/favorites',
}

export const NextRoute = (nextPageIri: IRI): APIRoute => ({
  method: 'GET',
  path: nextPageIri,
})

export type FavoriteAPIType = 'mine' | 'them' | 'both'

export enum FavoriteType {
  sent = 'sent',
  received = 'received',
  mutual = 'mutual',
}

export enum FavoriteOrder {
  alphabetical = 'alphabetical',
  oldest = 'oldest',
  mostRecent = 'mostRecent',
}

export type SearchParams = HydraSearchParams & {
  type: FavoriteAPIType
  orderBy?: 'firstname' | 'createdAt'
  orderValue?: 'asc' | 'desc'
}

export const setFavoriteOrderBy = (filter: FavoriteOrder): SearchParams['orderBy'] => {
  switch (filter) {
    case FavoriteOrder.alphabetical:
      return 'firstname'
    case FavoriteOrder.mostRecent:
    case FavoriteOrder.oldest:
    default:
      return 'createdAt'
  }
}

export const setFavoriteOrderValue = (filter: FavoriteOrder): SearchParams['orderValue'] => {
  switch (filter) {
    case FavoriteOrder.mostRecent:
      return 'desc'
    case FavoriteOrder.oldest:
    case FavoriteOrder.alphabetical:
    default:
      return 'asc'
  }
}

export const setFavoriteType = (filter?: FavoriteType): SearchParams['type'] => {
  switch (filter) {
    case FavoriteType.received:
      return 'them'
    case FavoriteType.mutual:
      return 'both'
    case FavoriteType.sent:
    default:
      return 'mine'
  }
}

export const setFavoriteAPIType = (filter?: FavoriteAPIType): FavoriteType => {
  switch (filter) {
    case 'them':
      return FavoriteType.received
    case 'both':
      return FavoriteType.mutual
    case 'mine':
    default:
      return FavoriteType.sent
  }
}

export type Response = HydraCollection<UserCard>
